var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1013 3.19189H12.7932C7.46142 3.19189 3.13916 7.51415 3.13916 12.8459V32.154C3.13916 37.4858 7.46142 41.808 12.7932 41.808H32.1013C37.4331 41.808 41.7553 37.4858 41.7553 32.154V12.8459C41.7553 7.51415 37.4331 3.19189 32.1013 3.19189Z",
    stroke: "white",
    strokeWidth: 4.63614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1704 21.2835C30.4087 22.8905 30.1342 24.5316 29.386 25.9735C28.6378 27.4154 27.454 28.5847 26.003 29.3151C24.5519 30.0454 22.9075 30.2996 21.3037 30.0415C19.6998 29.7835 18.2182 29.0262 17.0695 27.8776C15.9209 26.7289 15.1636 25.2472 14.9055 23.6434C14.6475 22.0396 14.9017 20.3952 15.632 18.9441C16.3624 17.4931 17.5317 16.3093 18.9736 15.5611C20.4155 14.8129 22.0566 14.5384 23.6636 14.7767C25.3027 15.0198 26.8201 15.7836 27.9918 16.9553C29.1635 18.127 29.9273 19.6444 30.1704 21.2835Z",
    stroke: "white",
    strokeWidth: 4.63614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLight);
export default __webpack_public_path__ + "static/media/instagram-light.27bcf9838305d4c307a416289afd01a7.svg";
export { ForwardRef as ReactComponent };